<template>
	<div class="head2_wrap">
		<div class="head2_box1 flex3">
			<img v-if="meauShow" @click="handMeau" class="hb_img1" src="@/images/heng3.png" />
			<div v-else class="back_box flex3" @click="backOne">
				<img src="@/images/left1.png">
				<span>返回</span>
			</div>
			<div class="hb_text">{{pageTitle}}</div>
			<div class="hb_img2 flex3">
				<img v-show="searchShow" @click="handSearch" src="@/images/zoom.png" />
			</div>
		</div>
		<transition name="fade">
			<div v-show="ltshow" class="head2_box2 animate__animated" :class="ltshow?'animate__slideInLeft':'animate__slideOutLeft'">
				<div class="hd2_item" @click="toPage(item)" v-for="(item,index) in headList" :key="index">{{ item.title}}</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	name: 'Header2',
	props: {
		searchShow: {
			type: Boolean,
			default: false,
		},
		meauShow: {
			type: Boolean,
			default: true,
		},
		pageTitle: {
			type: String,
			default: '徐州交控集团'
		}
	},
	data() {
		return {
			ltshow: false,
            hdtop:0
		};
	},
	computed: {
		...mapState(["headList"]),
	},
	created() {
        setTimeout(() => {
            this.hdtop = '1.23rem';
        }, 400);
    },
	methods: {
		handMeau() {
			this.ltshow = !this.ltshow;
		},
		handSearch() {
            this.$router.push('/search');
		},
		toPage(item) {
			this.ltshow = false;
			this.$router.push(item.name);
		},
		backOne() {
			window.history.back();
		},
	},
};
</script>

<style lang="scss">
.head2_wrap {
	.head2_box1 {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 1120;
		background-color: #004098;
		height: 1.23rem;
		padding: 0 0.5rem;
		.hb_img1 {
			width: 0.55rem;
		}
		.back_box {
			img {
				width: 0.28rem;
			}
			span {
				color: #fff;
				font-size: 15px;
				margin-left: 0.3rem;
			}
		}
		.hb_text {
			flex: 1;
			text-align: center;
			color: #fff;
			color: #fff;
			font-size: 17px;
			font-weight: 700;
			text-align: center;
		}
		.hb_img2 {
			img {
				width: 0.55rem;
			}
            span{
                font-size: 0.4rem;
                color: #fff;
                margin-left: 0.3rem;
                margin-top: 0.06rem;
            }
		}
	}
	.head2_box2 {
		position: fixed;
		top: 1.23rem;
		bottom: 0;
		left: 0;
		z-index: 1119;
        background-color: #fff;
		background-repeat: repeat;
		box-sizing: border-box;
		padding: 0 0.5rem;
		animation-duration: 0.3s;
		box-shadow: 5px 0 5px 0 rgba(0, 0, 0, 0.1);
		.hd2_item {
			display: block;
			text-align: left;
			color: #787878;
			font-size: 17px;
			font-weight: 700;
			padding: 0.45rem;
		}
	}
}
</style>